import { DetailsMenuItem } from 'shared';

/** The menu of supplier employees (the suppliers' representatives), instead of the client menu. */
export const SUPPLIER_MENU: DetailsMenuItem[] = [
  {
    text: 'OPEN_ORDERS_OF_YOUR_CLIENTS',
    url: 'backorders',
    icon: 'rc-icon-truck',
  },
];
